/**
 * @class Oskari.mapframework.bundle.oskariui.OskariUIBundle
 *
 * Applies required jquery-ui-components to app
 * Adds Dom Manager for managing external DOM references.
 *
 */
Oskari.clazz.define("Oskari.mapframework.bundle.oskariui.OskariUIBundle", function () {
  this.conf = {};
}, {
  "create": function create() {
    return this;
  },
  "update": function update(manager, bundle, bi, info) {},
  "start": function start() {
    /* We'll add our own Dom Manager */
    var partsMap = this.conf.partsMap || {};
    var domMgr = Oskari.clazz.create('Oskari.framework.bundle.oskariui.DomManager', jQuery, partsMap);
    Oskari.setDomManager(domMgr);
  },
  "stop": function stop() {}
}, {
  "protocol": ["Oskari.bundle.Bundle", "Oskari.bundle.BundleInstance"],
  "source": {
    "scripts": [{
      "type": "text/javascript",
      "src": "../../../../libraries/jquery/jquery-ui-1.12.1.custom.min.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../libraries/jquery/plugins/jquery.base64.min.js"
    }, {
      "type": "text/css",
      "src": "../../../../bundles/framework/oskariui/resources/css/jquery-ui-1.12.1.custom.css"
    }, {
      "type": "text/css",
      "src": "../../../../bundles/framework/oskariui/resources/bootstrap-grid.css"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/framework/oskariui/DomManager.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/framework/oskariui/Layout.js"
    }],
    "locales": [{
      "lang": "en",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/oskariui/resources/locale/en.js"
    }, {
      "lang": "fi",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/oskariui/resources/locale/fi.js"
    }, {
      "lang": "sv",
      "type": "text/javascript",
      "src": "../../../../bundles/framework/oskariui/resources/locale/sv.js"
    }]
  },
  "bundle": {
    "manifest": {
      "Bundle-Identifier": "oskariui",
      "Bundle-Name": "oskariui",
      "Bundle-Author": [{
        "Name": "jjk",
        "Organisation": "nls.fi",
        "Temporal": {
          "Start": "2012"
        },
        "Copyleft": {
          "License": {
            "License-Name": "EUPL",
            "License-Online-Resource": "http://www.paikkatietoikkuna.fi/license"
          }
        }
      }],
      "Bundle-Name-Locale": {
        "fi": {
          "Name": " style-1",
          "Title": " style-1"
        },
        "en": {}
      },
      "Bundle-Version": "1.0.0",
      "Import-Namespace": ["Oskari", "jquery"],
      "Import-Bundle": {}
    }
  },
  /**
   * @static
   * @property dependencies
   */
  "dependencies": ["jquery", "bb", "backbone"]
});
Oskari.bundle_manager.installBundleClass("oskariui", "Oskari.mapframework.bundle.oskariui.OskariUIBundle");
import '../../../../libraries/jquery/jquery-ui-1.12.1.custom.min.js'
import '../../../../libraries/jquery/plugins/jquery.base64.min.js'
import '../../../../bundles/framework/oskariui/resources/css/jquery-ui-1.12.1.custom.css'
import '../../../../bundles/framework/oskariui/resources/bootstrap-grid.css'
import '../../../../bundles/framework/oskariui/DomManager.js'
import '../../../../bundles/framework/oskariui/Layout.js'